import { render, staticRenderFns } from "./baseMcInbound.vue?vue&type=template&id=6c9f0471&scoped=true"
import script from "./baseMcInbound.vue?vue&type=script&lang=js"
export * from "./baseMcInbound.vue?vue&type=script&lang=js"
import style0 from "./baseMcInbound.vue?vue&type=style&index=0&id=6c9f0471&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9f0471",
  null
  
)

export default component.exports